import { Box, Stack } from "@mui/material";
import MuiGrid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";

const Grid = (props) => {
  const { autoAdjust = false, size = 6, sizeXs = 12, items = [] } = props;

  if (!items || items.length === 0) {
    return null;
  }

  let arrayItems = items;
  if (!Array.isArray(arrayItems)) {
    arrayItems = [items];
  }

  if (autoAdjust) {
    return (
      <Stack
        direction={{ xs: "column", lg: "row" }}
        useFlexGap
        spacing={2}
        component="ul"
        className="fr-raw-list"
        sx={{ alignItems: "center", flexWrap: "wrap", "& *": { width: { xs: "100%", lg: "auto" } } }}
      >
        {arrayItems.map((item) => (
          <Box key={item.key} component="li">
            {item}
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <MuiGrid container spacing={2} component="ul" className="fr-raw-list">
      {arrayItems.map((item) => (
        <MuiGrid key={item.key} component="li" size={{ xs: parseInt(sizeXs, 10), lg: parseInt(size, 10) }}>
          {item}
        </MuiGrid>
      ))}
    </MuiGrid>
  );
};

Grid.propTypes = {
  autoAdjust: PropTypes.bool,
  size: PropTypes.string,
  sizeXs: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export default Grid;
